import * as firebase from 'firebase/app'
import { serverURL } from '../assets/config/constants';

function getAuthBody() {
  const currentUser = firebase.auth().currentUser
  return {
    uid: currentUser && currentUser.uid,
    companyEmail: currentUser && currentUser.email
  }
}

export function isGoogleCalendarConnected() {
  return !!localStorage.getItem('gc_access_token')
}

export async function createMeeting(event) {
  const response = await fetch(`${serverURL}/google-calendar/create-meeting`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...getAuthBody(), event })
  })
  if (!response.ok) {
    const err = await response.json()
    throw new Error(err.error || 'Failed to create meeting')
  }
  return response.json() // { ok: true, eventId, event }
}

export async function updateMeeting(eventId, event) {
  const response = await fetch(`${serverURL}/google-calendar/update-meeting`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...getAuthBody(), eventId, event })
  })
  if (!response.ok) {
    const err = await response.json()
    throw new Error(err.error || 'Failed to update meeting')
  }
  return response.json()
}

export async function deleteMeeting(eventId) {
  const response = await fetch(`${serverURL}/google-calendar/delete-meeting`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...getAuthBody(), eventId })
  })
  if (!response.ok) {
    const err = await response.json()
    throw new Error(err.error || 'Failed to delete meeting')
  }
  return response.json()
}


// WEBPACK FOOTER //
// ./src/utils/googleCalendar.js